const styles = (theme) => ({
  root: {
    marginTop: theme.hvSpacing(2),
  },
  elements: {},
});

export default styles;
